import validate from "/app/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45sync_45global from "/app/app/middleware/auth-sync.global.js";
import manifest_45route_45rule from "/app/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  auth_45sync_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "workspace-access": () => import("/app/app/middleware/workspace-access.js"),
  "sidebase-auth": () => import("/app/node_modules/@sidebase/nuxt-auth/dist/runtime/middleware/sidebase-auth.js")
}